'use client';

import {useOpenExternalUrlModal} from '@web-catalog/store/externalUrlModal';

type Props = {
  url: string;
  raw: string;
  className?: string;
};

export const FakeUrl = ({url, raw, className}: Props) => {
  const openModal = useOpenExternalUrlModal();
  return (
    <span
      className={className}
      onClick={() => openModal({url, text: raw})}
      data-testid="external-link"
    >
      {raw}
    </span>
  );
};
